import { ShippingStateModel } from './shipping.state';
import { ShippingOption } from '../../../modules/checkout/models/delivery-methods';

export class UpsertShippingAction {
  static readonly type = '[Shipping] Upsert shipping';
  constructor(public payload: Partial<ShippingStateModel>) {}
}

export class SetAvailableShippingMethodsAction {
  static readonly type = '[Shipping] Set available shipping methods';
  constructor(
    public payload: {
      availableShippingMethods: ShippingOption[];
      selectedShippingMethod?: ShippingOption;
    }
  ) {}
}
